import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_workers_basic_wages_ever_reviewed_and_adjusted_for_the_enti'

export const dataPointDefinition = {
  retracedId: 'are_workers_basic_wages_ever_reviewed_and_adjusted_for_the_enti',
  name: "Are worker's basic wages ever reviewed and adjusted for the entire facility (or portion of the facility)?",
  description:
    '"Wage review and adjustment" refers to the process of reviewing (and then adjusting) worker basic wage rates for potential increases or decreases that might affect the entire facility (or at least a portion of the facility). \r\r\n\r\r\nExamples include: inflation, deflation, facility productivity, changes in legal minimum wage, changes in a collective bargaining agreement, review of wage grids / wage scales, review based on living cost surveys performed, etc.\r\r\n\r\r\n"Basic wage" means the rate of pay for a standard work period excluding additional payments like bonuses and overtime.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-10',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8200,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
